
import {
  Component, Prop, Watch, Mixins,
} from 'vue-property-decorator';
import { debounce } from 'ts-debounce';
import DataTableWrapper from '@/features/common/components/DataTableWrapper.vue';
import HistoryTableRow from '@/features/shipment-history/components/HistoryTableRow.vue';
import NoResultsFound from '@/features/common/components/NoResultsFound.vue'; import { HistoryItemType } from '@/features/shipment-history/types';
import { COLUMNS_WITHOUT_TITLE } from '@/features/shipment-history/helpers';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    DataTableWrapper,
    HistoryTableRow,
    NoResultsFound,
  },
})
export default class HistoryTable extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) historyItems!: HistoryItemType[];

  @Prop({ default: () => [] }) selectedItems!: HistoryItemType[];

  @Prop({ default: false }) isLoading!: boolean;

  @Prop({ default: true }) canFetchMore!: boolean;

  @Prop({ default: '' }) openedTrackingNumber!: string;

  private columnsWidths: number[] = [];

  get tableColumns(): string[] {
    return this.$store.getters.getHistoryTableColumns;
  }

  get allItemsSelected(): boolean {
    return this.selectedItems.length === this.historyItems.length;
  }

  set allItemsSelected(val: boolean) {
    this.$emit('toggleAll', val);
  }

  @Watch('tableColumns', { immediate: true })
  @Watch('historyItems.length')
  private async recalculateColumnsWidths(value: number) {
    if (!value) return;
    await this.$nextTick();
    this.calculateColumnsWidths();
  }

  @Watch('isTablet')
  private async recalculateColumnsWidthAfterTablet(val) {
    if (val) return;

    setTimeout(() => {
      this.calculateColumnsWidths();
    }, 0);
  }

  private mounted(): void {
    window.addEventListener('resize', this.windowResizeHandler);
  }

  private destroyed(): void {
    window.removeEventListener('resize', this.windowResizeHandler);
  }

  private calculateColumnsWidths(): void {
    this.columnsWidths = [];
    const headerColumns = document.querySelectorAll('.history-table__header-column');

    if (!headerColumns) return;

    this.columnsWidths = (Array.from(headerColumns) as HTMLElement[]).map(({ offsetWidth }) => {
      return offsetWidth;
    });
  }

  private toggleItem(item: HistoryItemType): void {
    this.$emit('toggleItem', item);
  }

  private getIsItemSelected(item: HistoryItemType): boolean {
    return this.selectedItems.includes(item);
  }

  private windowResizeHandler(): void {
    this.debounceCalculateColumnWidths();
  }

  private debounceCalculateColumnWidths = debounce(this.calculateColumnsWidths, 500);

  private getColumnTitle(column: string): string {
    if (COLUMNS_WITHOUT_TITLE.includes(column)) {
      return '';
    }

    return this.$t(`history.tables.${column}`) as string;
  }
}
